<template lang="pug">
    r-form(
        loading-text='Cargando nota de debito...'
        no-submit
        ref='form'
        reset-text='restablecer'
        submit-text='guardar'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submitUpdate'
    )
        template( slot='header-actions' )
            v-chip( 
                class='my-0' 
                label 
                small 
                text-color='white' 
                v-bind='chipProps' 
            ) {{ formData.payable_str }} &nbsp;
                v-icon( small ) lock
        template( slot='footer-actions' slot-scope='props' )
            v-btn(
                block
                :disabled='props.wait'
                v-bind='actionProps'
                @click='submitPayable'
            ) {{ formActionVerb }} pago
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, RForm } from '@/components/reusable_components/next'
    //
    import PurchaseDebitNoteModel from '@/models/Purchase/PchPurchaseDebitNote'
    import PurchaseDebitNoteFields from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteUpdateFields'
    //
    import TranslatorService from '@/services/translator'
    //
    export default {
        name: 'purchase-debit-note-update',
        components: {
            RForm,
        },
        computed: {

            /**
             * { item_description }
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            actionProps() {
                return {
                    color: this.formData.payable ? 'error' : 'success'
                }
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            chipProps() {
                return {
                    color: this.formData.payable ? 'success' : 'error'
                }
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            fieldsProps() {
                return {
                    document_type_title: this.fieldsVariant ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.formData.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            formActionVerb() {
                return this.formData.payable ? 'bloquear' : 'desbloquear'
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            formActionVerbPast() {
                return this.formData.payable ? 'bloqueada' : 'desbloqueada'
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            formProps() {
                return {
                    editable: false,
                    fields: PurchaseDebitNoteFields(this.fieldsProps).variant(this.fieldsVariant).readonly(),
                    loading: this.busy,
                    readonly: true,
                    switchEdit: true,
                    title: this.formTitle,
                }
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            fieldsVariant() {
                return this.formData.document_type
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            formTitle() {
                return `Nota de debito #${this.$route.params.id}`
            },
        },
        data() {
            return {
                busy: false,
                formData: {},
            }
        },
        methods: {

            /**
             * { item_description }
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * { item_description }
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * { function_description }
             *
             * @param      {<type>}  error   The error
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PurchaseDebitNoteModel, error.response.data))
            },

            /**
             * Fetches the object.
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            fetch() {
                return PurchaseDebitNoteModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             * Resets the object.
             */
            reset() {
                return this.setBusy(true).then(this.fetch).then(this.setBusy)
            },

            /**
             * Sets the busy.
             *
             * @param      {boolean}  [busy=false]  The busy
             * @return     {Promise}  { description_of_the_return_value }
             */
            async setBusy(busy = false) {
                this.busy = busy
            },

            /**
             * Sets the form data.
             *
             * @param      {<type>}  model   The model
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitPayable() {
                return this.toWait(true).then(this.toPayable).then(this.toWait)
            },

            /**
             * { function_description }
             */
            successPayable() {
                return this.setSuccessSnackbar(`Nota de debito ${this.formActionVerbPast} exitosamente.`)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  model   The model
             * @return     {<type>}  { description_of_the_return_value }
             */
            toPayable(model) {
                return model
                    .togglePayable()
                    .sync(model.toPayable())
                    .then(this.successPayable)
                    .then(this.reset)
                    .catch(this.error)
            },

            /**
             * { function_description }
             *
             * @param      {boolean}  [value=false]  The value
             * @return     {<type>}   { description_of_the_return_value }
             */
            toWait(value = false) {
                return this.$refs.form.setWait(value)
            },

            /**
             * 
             */
            triggerProvider(ctx) {
                this.formData.pch_provider_branch_offices = ctx
                    .getInput('pch_provider_id')
                    .getSelected()
                    .getProperty('branch_offices', [])
            }
        },
        mounted() {
            this.setTitleTopBar(this.formTitle).then(this.reset)
        },
    }
</script>